"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Image_1 = __importDefault(require("../Image/Image"));

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Icon_meta_1 = require("./Icon.meta");

var Accessibility_1 = require("../Accessibility/Accessibility");

var Icon =
/** @class */
function (_super) {
  __extends(Icon, _super);

  function Icon(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Icon_meta_1.ICON_CATEGORY_KEY;
    _this.componentKey = Icon_meta_1.ICON_COMPONENT_KEY;
    return _this;
  }

  Icon.prototype.imageAccessibleProps = function (accessibilityContext) {
    var _a = this.props,
        _b = _a.addAccessibleText,
        addAccessibleText = _b === void 0 ? true : _b,
        asset = _a.asset;
    var props = {};

    if (addAccessibleText) {
      props['aria-label'] = accessibilityContext.accessibilityText(asset, 'Icon');
    }

    return props;
  };

  Icon.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        onClick = _a.onClick,
        _b = _a.addAccessibleText,
        addAccessibleText = _b === void 0 ? true : _b,
        props = __rest(_a, ["className", "onClick", "addAccessibleText"]);

    var accessibilityContext = this.context;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className,
      "aria-hidden": !addAccessibleText
    }, react_1.default.createElement(Image_1.default, __assign({
      className: className,
      onClick: onClick
    }, props, this.imageAccessibleProps(accessibilityContext))));
  };

  Icon.contextType = Accessibility_1.AccessibilityContext;
  Icon = __decorate([mobx_react_1.observer], Icon);
  return Icon;
}(shared_1.ComponentBase);

exports.Icon = Icon;
exports.default = shared_1.InjectedStyledComponent(Icon, Icon_meta_1.ICON_CATEGORY_KEY, Icon_meta_1.ICON_COMPONENT_KEY);